import { render } from "./HomePart6.vue?vue&type=template&id=2a9781a4&scoped=true&ts=true"
import script from "./HomePart6.vue?vue&type=script&lang=ts"
export * from "./HomePart6.vue?vue&type=script&lang=ts"

import "./HomePart6.vue?vue&type=style&index=0&id=2a9781a4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9781a4"]])

export default __exports__